import React from "react";
import { IFilterReport } from "../types/filter.type";
import FilterRPTUser from "../components/common/filters/report/rpt-user/FilterRPTUser";
import FilterRPTPost from "../components/common/filters/report/rpt-post/FilterRPTPost";
import FilterRPTComment from "../components/common/filters/report/rpt-comment/FilterRPTComment";

type ReportType = {
  title: string;
  Filter: React.ElementType<IFilterReport>;
};
const reports: { [key: string]: ReportType } = {
  fos_rpusers: {
    title: "Người dùng đăng ký",
    Filter: FilterRPTUser,
  },
  fos_rpposts: {
    title: "Thống kê bài đăng",
    Filter: FilterRPTPost,
  },
  fos_rpcomments: {
    title: "Thống kê bình luận",
    Filter: FilterRPTComment,
  },
};
export default reports;
